import Modal from './Modal'
import CardToggle from './CardToggle';

export const ModalComponent = Modal,
            CardToggleComponent = CardToggle